<div class="form-row">
  <div class="form-check">
    <label>
      <input type="checkbox" (change)="updateConsentSelection(consent)"
        [checked]="inConsentSelection(consent)"
        [disabled]="order.payedAt">

      <span class="label" [innerHTML]="consent.name"></span>
      @if (consent.isRequired) {
        <span class="required-indicator">*</span>
      }
      @if (consent.resource) {
        <a class="consent-resource-link"
          [href]="consent.resource.link"
          target="_blank">
          <span class="cm-icon cm-icon-pop-out small" aria-hidden="true"></span>
        </a>
      }
    </label>
  </div>
</div>
